import axiosInstance from "./axiosInstance";

const PROFILE_USERS_BASE_URL = "/profile/users";
const PROFILE_USER_BASE_URL = "/profile/user";
const PROFILE_UPDATE_BASE_URL = "/profile/update";
const ACTIVATE_USER_BASE_URL = "profile/activate";
const DEACTIVATE_USER_BASE_URL = "profile/deactivate";
const PROFILE_MERCHANT_USERS_BASE_URL = "/profile/merchant/users";
const PROFILE_PIN_SETUP_URL = "/profile/pin/setup";
const PROFILE_PIN_CHANGE_URL = "/profile/pin/change";
const MANAGEMENT_USER_ACTIONS_BASE_URL = "/management/users";

const profileService = {
  getCurrentUser: async () => {
    const response = await axiosInstance.get(PROFILE_USER_BASE_URL);
    return response.data;
  },

  getAllUsers: async () => {
    const response = await axiosInstance.get(PROFILE_USERS_BASE_URL);
    return response.data;
  },

  getAllMerchantUsers: async () => {
    const response = await axiosInstance.get(PROFILE_MERCHANT_USERS_BASE_URL);
    return response.data;
  },

  createMerchantProfile: async (userData) => {
    const response = await axiosInstance.post(
      PROFILE_MERCHANT_USERS_BASE_URL,
      userData,
    );
    return response.data;
  },

  getUserById: async (userId) => {
    const response = await axiosInstance.get(
      `${PROFILE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await axiosInstance.put(
      `${PROFILE_UPDATE_BASE_URL}/${userId}`,
      userData,
    );
    return response.data;
  },

  activateUser: async (userId) => {
    const response = await axiosInstance.get(
      `${ACTIVATE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },

  deactivateUser: async (userId) => {
    const response = await axiosInstance.get(
      `${DEACTIVATE_USER_BASE_URL}/${userId}`,
    );
    return response.data;
  },

  setupPin: async (newPin, confirmPin) => {
    const response = await axiosInstance.post(PROFILE_PIN_SETUP_URL, {
      newPin,
      confirmPin,
    });
    return response.data;
  },

  changePin: async (currentPin, newPin, confirmPin) => {
    const response = await axiosInstance.post(PROFILE_PIN_CHANGE_URL, {
      currentPin,
      newPin,
      confirmPin,
    });
    return response.data;
  },

  unblockUserPin: async (userId) => {
    const response = await axiosInstance.patch(
      `${MANAGEMENT_USER_ACTIONS_BASE_URL}/${userId}/actions`,
      { action: "REMOVE_PIN_LOCK" },
    );
    return response.data;
  },
};

export default profileService;
